import { useAppSelector } from "app/hooks";
import { useAuth } from "hooks/auth";
import { querystring } from "models/Listing";
import { selectCurrentStoreData } from "reduxState/currentStoreData/currentStoreDataSlice";
import useSWR from "swr";
import { ListingProps } from "types/listing";
import { getEnvVariable } from "utilities/env";

export const useAnalytics = () => {
  const { code } = useAppSelector(selectCurrentStoreData);
  const { fetcher } = useAuth();

  const useGeneralOverviewAnalytics = (props?: ListingProps) => {
    return useSWR(
      () =>
        code
          ? `${getEnvVariable(
              "REACT_APP_API_URL",
            )}/${code}/analytics/dashboard/general-overview${querystring(
              props,
            )}`
          : null,
      fetcher,
    );
  };

  const getGeneralOverviewBatchData = async (
    codes: string[],
    props?: ListingProps,
  ) => {
    if (codes.length === 0) return;

    const responses = await Promise.all(
      codes.map((code) =>
        fetcher(
          `${getEnvVariable(
            "REACT_APP_API_URL",
          )}/${code}/analytics/dashboard/general-overview${querystring(props)}`,
          {
            headers: { "Content-Type": "application/json" },
            method: "GET",
          },
        ),
      ),
    ).then((resp) => resp.map((r) => r));

    return responses;
  };

  const useUnitsOverviewAnalytics = (
    walletTypeCode: string,
    props?: ListingProps,
  ) => {
    return useSWR(
      () =>
        code && walletTypeCode
          ? `${getEnvVariable(
              "REACT_APP_API_URL",
            )}/${code}/analytics/units-overview/${walletTypeCode}${querystring(
              props,
            )}`
          : null,
      fetcher,
    );
  };

  return {
    useGeneralOverviewAnalytics,
    useUnitsOverviewAnalytics,
    getGeneralOverviewBatchData,
  };
};
